import { useMutation } from '@tanstack/react-query';
import API from 'api/API';
import { QueryKeys } from 'api/models/QueryKeys';
import { SurgeryNotifyCheckedOutRequest } from 'api/models/Surgeries';
import { queryClient } from 'components/QueryClientProvider/QueryClientProvider';

export const useNotifySurgeryCheckedOut = () => {
  return useMutation({
    mutationFn: async (request: SurgeryNotifyCheckedOutRequest) => {
      await API.surgeries.notifySurgeryCheckedOut(request);
    },
    onSuccess: () =>
      Promise.all([
        queryClient.invalidateQueries([QueryKeys.Order]),
        queryClient.invalidateQueries([QueryKeys.Orders]),
      ]),
  });
};
